import { render, staticRenderFns } from "./ItemImageAssociationScreen.vue?vue&type=template&id=6136e9cd&"
import script from "./ItemImageAssociationScreen.vue?vue&type=script&lang=js&"
export * from "./ItemImageAssociationScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports